__turbopack_context__.v({
  "baseLink": "JMZDmG_baseLink",
  "baseListItem": "JMZDmG_baseListItem",
  "firstLevelLink": "JMZDmG_firstLevelLink",
  "secondLevelLink": "JMZDmG_secondLevelLink",
  "secondLevelList": "JMZDmG_secondLevelList",
  "thirdLevelItem": "JMZDmG_thirdLevelItem",
  "thirdLevelList": "JMZDmG_thirdLevelList",
  "topListItem": "JMZDmG_topListItem",
});
